import React from 'react'
import { GetServerSideProps, NextPage } from 'next'
import Head from 'next/head'
import dynamic from 'next/dynamic'
import { FAQPageJsonLd } from 'next-seo'

const Footer = dynamic(() => import('@/components/home/footer'))
const KPHead = dynamic(() => import('@/components/head'))
const TopNavigation = dynamic(() => import('@/components/top-navigation'))
const GooglePlay = dynamic(() => import('@/components/common/google-play-btn'))
const NoQuestion = dynamic(() => import('@/components/faq/no-question'))
const FAQFollow = dynamic(() => import('@/components/faq/follow-google'))
const MainFAQ = dynamic(() => import('@/components/faq/main-faq'))

import { fetchCategoryById, fetchCategoryListPage } from '@/lib/api'
import { createResource, useResource } from '@/lib/i18n'
import { BLOG_FAQ_CATEGORY } from '@/lib/constant'
import { useQAList } from '@/lib/faq-list'
import { useCurrentLanguage } from '@/lib/current-language'
import { captureException } from '@sentry/nextjs'
import { setCustomHeaders } from '@/lib/utils'

const resource = createResource({
  en: {
    description:
      'find your answer regarding cash loan Kredit Pintar, payment method, payment installment and more here.',
  },
  id: {
    description:
      'Temukan jawaban Anda mengenai pinjaman tunai Kredit Pintar, metode pembayaran, cicilan pembayaran dan lainnya disini.',
  },
})

type IParams = {
  blogData: any[]
  categoryList: any[]
}

const FAQ: NextPage<IParams> = (params: IParams) => {
  const { t } = useResource(resource)
  const { language: lng } = useCurrentLanguage()
  const { categories, qaList } = useQAList({ language: lng, categoryList: params.categoryList })

  return (
    <>
      <FAQPageJsonLd
        mainEntity={qaList.map(({ question, answer }) => ({
          questionName: question.replace(/\"/g, '\\"'),
          acceptedAnswerText: answer.replace(/\"/g, '\\"'),
        }))}
      />
      <KPHead metaTitle="faq" />
      <Head>
        <meta name="description" content={t('description')} />
      </Head>
      <TopNavigation />
      <FAQFollow />
      <MainFAQ blogData={params.blogData} categoryList={categories} />
      <NoQuestion />
      <Footer />
      <GooglePlay />
    </>
  )
}

export default FAQ

export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
  setCustomHeaders(req, res, 'faq')
  try {
    const result: any = await Promise.all([fetchCategoryListPage(), fetchCategoryById(BLOG_FAQ_CATEGORY, 1, 10)])
    return {
      props: {
        categoryList: result[0]?.acf,
        blogData: result[1].data,
      },
    }
  } catch (err) {
    console.log(err)
    captureException(err)
    return {
      props: {
        categoryList: [],
        blogData: [],
      },
    }
  }
}
